import React from 'react';
import { render } from 'react-dom';

import MainNavigationBar from "./MainNavigationBar";

const id = document.currentScript.dataset.navigationId;
const node = document.getElementById(id);
const browseAllUrl = document.currentScript.dataset.browseAllUrl;
const searchCategoryUrl = document.currentScript.dataset.searchCategoryUrl;
const regionData = JSON.parse(document.currentScript.dataset.regionData);

render(
  <MainNavigationBar
    browseAllUrl={browseAllUrl}
    searchCategoryUrl={searchCategoryUrl}
    regionData={regionData}
  />, node
);
